import {listGender, listTT_Don_Kinh} from "data/list";
import React from "react";
import {FIELD_TYPE, tabKeys} from "types/enums";

import {TabsProps} from "antd";
import List1 from "./List1/List1";
import List2 from "./List2/List2";
import List3 from "./List3/List3";
const {INPUT, DATE, COMBO_BOX} = FIELD_TYPE;
const items: TabsProps["items"] = [
  {
    key: tabKeys.GLASSES.LIST_1,
    label: `Đơn kính kê`,
    children: <List1></List1>,
  },
  {
    key: tabKeys.GLASSES.LIST_2,
    label: `Đơn kính đã bán`,
    children: <List2></List2>,
  },
  // {
  //   key: tabKeys.GLASSES.LIST_3,
  //   label: `Đơn kính hoàn trả`,
  //   children: <List3></List3>,
  // },
  // {
  //   key: tabKeys.MEDICINE_STORE.LIST_3,
  //   label: `Đơn hoàn trả`,
  //   children: <List3></List3>,
  // },
];
const fields: any = [
  {
    type: INPUT,
    name: "maPK",
    label: "Mã phiếu khám",
  },
  {
    type: INPUT,
    name: "maBenhNhan",
    label: "Mã bệnh nhân",
  },
  {
    type: INPUT,
    name: "id",
    label: "Mã đơn bán",
  },
  {
    type: INPUT,
    name: "hoTen",
    label: "Họ tên",
  },
  {
    type: DATE,
    name: "ngaySinh",
    label: "Ngày sinh",
  },
  {
    type: DATE,
    name: "start",
    label: "Ngày tạo từ",
  },
  {
    type: DATE,
    name: "end",
    label: "Ngày tạo đến",
  },
  {
    type: DATE,
    name: "ngayBanTu",
    label: "Ngày bán từ",
  },
  {
    type: DATE,
    name: "ngayBanDen",
    label: "Ngày bán đến",
  },
  {
    type: COMBO_BOX,
    name: "storeId",
    label: "Kho bán",
  },
  {
    type: COMBO_BOX,
    name: "dateOfBirth",
    options: listGender,
    label: "Giới tính",
    expand: true,
  },
  {
    type: INPUT,
    name: "dienThoai",
    label: "Số điện thoại",
    expand: true,
  },

  {
    type: COMBO_BOX,
    name: "status",
    label: "Trạng thái đơn bán kính",
    options: listTT_Don_Kinh,
    expand: true,
  },
];

export {fields, items};
